<div class="flex-column submenu-component"
     [class.has-promobar]="!component.promobar_hide && component.promobar_text">

    <!-- columns -->
    <div class="wrap custom-scrollbar">
        <div [grid]="12">
            @for (column of component.columns; let isFirstColumn = $first; let isLastColumn = $last; track $index) {
            @if (ifCustomerGroup(column.visibility) && !column.hide) {
            <div class="submenu-component__column p-t-3"
                 [class.is-last]="isLastColumn"
                 [class.has-background]="column.background_color && isLastColumn"
                 [ngClass]="(column.background_color && !isLastColumn) ? column.background_color : ''"
                 [gridColumn]="isLastColumn ? 3 : 2"
                 [gridColumnOffset]="isFirstColumn ? 1 : undefined">

                @for (block of column.blocks; track $index; let isFirstBlock = $first) {
                <div [style.--product-inrow-index]="getIndex(block)">
                    @if (ifCustomerGroup(block.visibility) && !block.hide) {
                    @if (column.background_color && isLastColumn) {
                    <div class="pos-absolute top-0 bottom-0 left-0 z-1 submenu-component__bg"
                         [ngClass]="[column.background_color || '', block.type === 'lists' ? 'is-list' : '']"></div>
                    }

                    <!-- hide block -->
                    <div class="pos-relative z-2 p-b animation-fade-in animation-block-movement"
                         [class.p-t]="isFirstBlock"
                         [toggleClass]="'animation-fade-in animation-block-movement'"
                         [toggleClassBy]="outletOptions?.context?.toggleGroupId">

                        <!-- links -->
                        @if (block.type === 'links' && block.links.length) {
                        <ul class="submenu-component__block is-link"
                            [ngClass]="{'m-t-3': !isFirstBlock}">

                            @for (link of block.links; track $index) {
                            @if (ifCustomerGroup(link.visibility)) {
                            <li class="m-t-1"
                                [ngClass]="link.image || isFirstColumn ? 'submenu-component__item' : 'm-b-2' "
                                csOverrideId
                                [elementId]="link.text"
                                [elementIdPath]="outletOptions?.context?.tabName">
                                <href [link]="link.link"
                                      [hrefClass]="'link'">
                                    <span class="w-12 flex flex-middle submenu-component__link"
                                          [gtmTrackClick]="{category: 'MegaNav', action: 'MegaNav Links', label: 'MegaNav Links ' + link.link}">

                                        <!-- image -->
                                        @if (link.image) {
                                        <div class="w-12 m-r-2 ratio-1-1">
                                            <img [dfImage]="link.image"
                                                 ratio="1"
                                                 [alt]="link.text"
                                                 fill>
                                        </div>
                                        }

                                        <!-- link -->
                                        <span class="submenu-component__link-text"
                                              [ngClass]="[isFirstColumn ? 'h2' : link.text_style || 'p1', link.text_color || 'col-b']"
                                              csOverrideId
                                              [elementId]="link.text"
                                              *iCms="'text' of link"></span>

                                        <!-- label -->
                                        <sup class="m-l-1 fs-2"
                                             [ngClass]="link.label_text_color"
                                             *iCms="'label_text' of link; skipEmpty: true"></sup>
                                    </span>
                                </href>
                            </li>
                            }
                            }
                        </ul>
                        }

                        <!-- images -->
                        @if (block.type === 'images' && block.images.length) {
                        <div class="pos-relative z-2 submenu-component__block is-image p-t-1"
                             [ngClass]="block.images.length === 1 ? 'has-one' : block.images.length === 2 ? 'has-two' :''"
                             [grid]="block.images.length > 1 ? 2 : 1">
                            @for (image of block.images; track $index) {
                            @if (ifCustomerGroup(image.visibility)) {
                            <href [link]="image.link">
                                <div
                                     [gtmTrackClick]="{category: 'MegaNav', action: 'MegaNav Features', label: 'MegaNav Features ' + image.link}">
                                    <div class="submenu-component__image"
                                         csOverrideId
                                         [elementIdImage]="image.image">
                                        <img class="w-12"
                                             [dfImage]="image.image"
                                             [ratio]="image.ratio || 'ratio-3-4'"
                                             [alt]="image.text">
                                    </div>

                                    <div class="m-t-1 p1"
                                         *iCms="'text' of image; skipEmpty: true"></div>
                                </div>
                            </href>
                            }
                            }
                        </div>
                        }

                        <!-- lists -->
                        @if (block.type === 'lists' && block.lists.length) {
                        <ul class="submenu-component__block is-list p-t-1"
                            [ngClass]="{'m-t-3': !isFirstBlock}">
                            @for (list of block.lists; track $index) {
                            @if (ifCustomerGroup(list.visibility)) {
                            <li class="m-t-1 m-b-3">
                                <href [link]="list.link"
                                      [hrefClass]="'link'">
                                    <span class="w-12 flex flex-middle"
                                          [gtmTrackClick]="{category: 'MegaNav', action: 'MegaNav Links', label: 'MegaNav Links ' + list.link}">

                                        <!-- dot-list -->
                                        <div class="list-dots m-r-2 b-radius-max bg-col-w"></div>

                                        <!-- link -->
                                        <span class="flex flex-column">
                                            <div [ngClass]="[list.text_color || 'col-b', list.text_style || 'p1']"
                                                 *iCms="'text' of list"></div>
                                            <div [ngClass]="[list.text_color || 'col-b', list.copy_text_style || 'c1']"
                                                 *iCms="'copy_text' of list"></div>
                                        </span>
                                    </span>
                                </href>
                            </li>
                            }
                            }
                        </ul>
                        }

                        <!-- colour_block -->
                        @if (block.type === 'colour_block' && block.colour_block.length) {
                        <div class="pos-relative z-2 submenu-component__block colour__block p-t-1">
                            @for (colourBlock of block.colour_block; track $index) {
                            @if (ifCustomerGroup(colourBlock.visibility)) {
                            <div class="submenu-component__block ratio-3-4">
                                <div class="fill flex flex-middle flex-justify-center"
                                     [ngClass]="[colourBlock.background_color || '', colourBlock.text_color || '']">
                                    <div class="flex flex-column center m-t-2">
                                        <div [ngClass]="colourBlock.title_copy_style"
                                             *iCms="'title_copy' of block"></div>

                                        <div class="m-t-1 m-b-6"
                                             [ngClass]="colourBlock.title_style"
                                             *iCms="'title' of colourBlock"></div>

                                        <href [link]="colourBlock.link">
                                            <div [ngClass]="colourBlock.cta_style"
                                                 [gtmTrackClick]="{category: 'MegaNav', action: 'MegaNav Links', label: 'MegaNav Links ' + colourBlock.link}"
                                                 *iCms="'cta_text' of colourBlock"></div>
                                        </href>
                                    </div>
                                </div>
                            </div>
                            }
                            }
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>
            }
            }
        </div>
    </div>

    <!-- promo bar -->
    @if (!component.promobar_hide && component.promobar_text) {
    <div class="w-12 submenu-component__promobar"
         [ngClass]="component.promobar_background_color || ''">
        <div class="wrap p-t-3 p-b-3 submenu-component__promobar">
            <href [link]="component.promobar_link">
                <div class="center"
                     [ngClass]="[component.promobar_text_color || '', component.promobar_text_style || '']"
                     *iCms="'promobar_text' of component"></div>
            </href>
        </div>
    </div>
    }
</div>